<template>
  <div :class="checkList[0] ? 'outside_wrap' : ''">
    <div v-for="(item, i) in checkList" :key="i" :class="i > 0 ? 'item border_style' : 'item'">
      <div class="wrap">
        <div class="row">
          <span class="label">{{ item.itemName }}</span>
          <div class="img_wrap">
            <span class="text">{{ item.amount }}{{ item.itemUnix }}</span>
            <img
              v-if="page"
              class="deleteDrug"
              src="@funcPuzzle/mini_doctor/deleteDrug.png"
              @click="deleteDrug(i)"
            />
          </div>
        </div>
        <div v-if="item.prescripOrderType !== '2'" class="row">
          <span class="label">部位：</span>
          <span class="text">
            {{ getKeyValueText('body_parts', item.bodyPart) }}
          </span>
        </div>
        <div v-if="item.prescripOrderType === '2'" class="row">
          <span class="label">样本类型：</span>
          <span class="text">
            {{ getKeyValueText('sample_type', item.sampleType) }}
          </span>
        </div>
        <div class="row">
          <span class="label">执行科室：</span>
          <span class="text">{{ item.exeDeptName }}</span>
        </div>
        <div class="row last_row">
          <span class="label">说明：</span>
          <span class="text">{{ item.detailDesc || '' }}</span>
        </div>
        <div
          v-if="['1', '2'].includes(item.prescripOrderType) && viewAction"
          class="check_btn"
          @click="checkResult(item)"
        >
          <span>查看结果</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
export default {
  props: {
    checkList: {
      type: [Array],
      default: () => {
        return []
      }
    },
    viewAction: {
      type: Boolean,
      default: true
    },
    page: {
      type: String,
      default: ''
    },
    patientID: {
      type: String,
      default: ''
    },
    visitNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    getKeyValueText,
    deleteDrug(val) {
      const index = this.checkList.findIndex((item, index) => index === val)
      // eslint-disable-next-line vue/no-mutating-props
      this.checkList.splice(index, 1)
      this.$bus.emit('deleteCheck', this.checkList)
    },
    checkResult(item) {
      console.log(this.visitNo, '87')
      if (item.prescripOrderType === '1') {
        uni.navigateTo({
          url: `/mine/checkTheResult/checkTheResult?patientID=${this.patientID}&visitNo=${this.visitNo}`
        })
      } else if (item.prescripOrderType === '2') {
        uni.navigateTo({
          url: `/mine/checkTheResult/testTheResult?patientID=${this.patientID}&visitNo=${this.visitNo}`
        })
      }
    }
  },
  beforeDestroy() {
    this.$bus.off('deleteCheck')
  }
}
</script>

<style lang="scss" scoped>
.outside_wrap {
  width: 100%;
  border-bottom: 0.021333rem solid #ececec;
  .item {
    box-sizing: border-box;
    width: 14.634667rem;
    margin-left: 0.682667rem;
    padding: 0.682667rem 0;
  }
  .border_style {
    border-top: 0.021333rem solid #ececec;
  }
}
.wrap {
  width: 100%;
}
.row {
  padding-bottom: 0.64rem;
  display: flex;
  justify-content: space-between;
  .text {
    font-size: 0.64rem;
    color: #222;
  }
  .img_wrap {
    display: flex;
    align-items: center;
    .deleteDrug {
      width: 0.853333rem;
      height: 0.853333rem;
      background: #ececec;
      border-radius: 50%;
      margin-left: 0.426667rem;
    }
  }
  .label {
    font-size: 0.64rem;
    font-weight: 400;
    color: #888888;
    max-width: 11.52rem;
  }
}
.last_row {
  padding-bottom: 0;
}
.check_btn {
  text-align: center;
  width: 14.634667rem;
  height: 1.877333rem;
  line-height: 1.877333rem;
  border-radius: 0.938667rem;
  font-size: 0.682667rem;
  border: 0.021333rem solid #0089ff;
  background-color: #fff;
  color: #0089ff;
  margin-top: 0.64rem;
}
</style>
